import React from "react";

import AccessDeniedIcon from "../../icons/access-denied-icon";

const AccessDeniedResponse = () => {
  return (
    <div className="catch-response">
      <div className="wrapper">
        <AccessDeniedIcon />
        <h3>دسترسی ممنوع است!</h3>
        <p>متاسفانه! شما به این صفحه دسترسی ندارید.</p>
      </div>
    </div>
  );
};

export default AccessDeniedResponse;
